module.exports = __webpack_public_path__ + "img/wx-code.a089c7f4.jpg";